import CreateSettingProject from "../components/CreateSettingProject";
import useCreateSettingProject from "../hooks/useCreateSettingProject";

const CreateSettingProjectPage = () => {
    const props = useCreateSettingProject();
    return <CreateSettingProject {...props} />
}

export default CreateSettingProjectPage;